/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m22.559 11.008-9.594-9.594a1.415 1.415 0 0 0-2.001 0L8.972 3.407l2.527 2.527a1.68 1.68 0 0 1 2.128 2.142l2.436 2.436a1.683 1.683 0 1 1-1.008.95L12.781 9.19v5.977a1.684 1.684 0 1 1-1.384-.05V9.086a1.683 1.683 0 0 1-.914-2.208l-2.49-2.492-6.579 6.577a1.416 1.416 0 0 0 0 2.002l9.595 9.594a1.416 1.416 0 0 0 2 0l9.55-9.55a1.415 1.415 0 0 0 0-2.001"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGit as Git };
